import type { ReactNode } from 'react';
import { Crumbs, useCrumbTitle } from '../nav/crumbs';
import { IconArrowLeft } from './icons';

/*
 * Единая шапка страницы для всего приложения (дизайн-система 3.12 PageHead):
 * слева стрелка «назад» (если есть куда возвращаться), затем название,
 * справа действие, ниже подзаголовок. Над названием — хлебные крошки
 * (3.64, решение Ильи 25.09.2026 — вернуть везде): путь собирает стопка
 * экранов, шапка только называет себя в нём своим названием.
 */
export function PageHeader({
  title,
  subtitle,
  onBack,
  action,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  onBack?: () => void;
  action?: ReactNode;
}) {
  useCrumbTitle(typeof title === 'string' ? title : '');
  return (
    <div className="page-header">
      <Crumbs />
      <div className="page-head">
        {onBack && (
          <button className="ibtn outline sm" title="Назад" aria-label="Назад" onClick={onBack}>
            <IconArrowLeft />
          </button>
        )}
        <h1>{title}</h1>
        {action}
      </div>
      {subtitle ? <p className="page-sub">{subtitle}</p> : null}
    </div>
  );
}
